export const actions = {
  setPlaylist({ commit }, payload) {
    commit("SET_PLAYLIST", payload);
  }
};
